import React from 'react'
import PropTypes from 'prop-types'
import { date, constants } from 'common/helpers'

import composeDialogModal from 'components/modal/DialogModal/composeDialogModal'

import messages from './messages'


const FrequencyChangeSuccessModal = composeDialogModal({
  name: constants.modals.FrequencyChangeSuccess,
  title: messages.title,
  subText: messages.hint,
  contentMessage: ({ data: { nextShippingDate, shippingPeriod } }) => {
    const nextDate = date.formatDate(nextShippingDate, 'MMM DD', true)

    return {
      ...messages.text,
      tag: 'div',
      values: {
        date: nextDate,
        period: shippingPeriod,
      },
    }
  },
  propTypes: {
    data: PropTypes.shape({
      nextShippingDate: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
      shippingPeriod: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
    }).isRequired,
  },
})

export default FrequencyChangeSuccessModal
